import script from "./AddBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBtn.vue?vue&type=script&setup=true&lang=js"

import "./AddBtn.vue?vue&type=style&index=0&id=27af611c&lang=scss"

const __exports__ = script;

export default __exports__